// extracted by mini-css-extract-plugin
export default {"container":"LeadingVisual-module__container--BTG5o"};